import Vue from 'vue';
import App from './App.vue';
import router from './router'; // 路由
import store from './store'; // 状态管理store
import '@/styles/index.scss'; //全局样式
import '@/styles/themes.scss'; //主题变量
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 菜单和路由权限控制
import '@/permission';
import watermarkFile from '@/plugins/watermark'; //水印
import hasPermi from '@/plugins/hasPermi'; //操作权限

import i18n from './i18n';

Vue.directive('watermark', watermarkFile);
Vue.directive('hasPermi', hasPermi);
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
